<template>
  <div
    data-testid="public-footer-credits"
    class="public-footer-credits flex flex-wrap items-center justify-center gap-x-4 gap-y-3"
    :class="{ 'public-footer-credits--compact': compact }"
  >
    <span
      v-if="!compact && showQRestooCredit"
      class="text-slate-300 dark:text-slate-600 select-none"
      aria-hidden="true"
    >·</span>
    <a
      v-if="showQRestooCredit"
      href="https://qrestoo.com" target="_blank" rel="noopener noreferrer" class="public-footer-credits__qrestoo-link inline-flex items-center gap-2 min-h-[44px] min-w-[44px] rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200" aria-label="QRestoo">
      <img src="/logos/QRestoo-app-logo--rounded.png" alt="QRestoo" width="24" height="24" class="public-footer-credits__qrestoo-logo" />
      <span class="underline hover:no-underline text-primary">{{ $t('public.siteCreatedViaQRestoo') }}</span>
    </a>
    <a
      href="https://dlrwebsolutions.com"
      target="_blank"
      rel="noopener noreferrer"
      class="public-footer-credits__dlr-link inline-flex items-center gap-2 min-h-[44px] min-w-[44px] rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200"
      :aria-label="$t('public.sitePoweredByDLR')"
    >
      <span class="underline hover:no-underline text-primary">{{ $t('public.sitePoweredByDLR') }}</span>
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineProps({
  /** When true, use tighter layout (e.g. single line, smaller gaps). */
  compact: { type: Boolean, default: false },
  /** When true, show "Site created by QRestoo" link (restaurant public pages only; set false on landing). */
  showQRestooCredit: { type: Boolean, default: true },
})

const appHomeUrl = computed(() => {
  const fromEnv = import.meta.env.VITE_APP_URL ?? ''
  if (fromEnv) return (fromEnv + '').replace(/\/$/, '') || '/'
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }
  return '/'
})
</script>

<style scoped>
.public-footer-credits__qrestoo-logo,
.public-footer-credits__dlr-logo {
  pointer-events: none;
}
.public-footer-credits--compact {
  gap: 0.5rem 1rem;
}
</style>
